export function formatMicrosoftOAuthError(
  description: string | null | undefined,
  fallback: string,
): string {
  if (!description?.trim()) {
    return fallback;
  }

  const decoded = decodeURIComponent(description.replace(/\+/g, " "));

  if (decoded.includes("AADSTS50020")) {
    return (
      "This Microsoft app is restricted to your organization's Azure directory. " +
      "Sign in with your work or school account, or ask your admin to allow personal " +
      "Microsoft accounts in the Azure app registration and set tenant ID to consumers (personal) or common (work + personal)."
    );
  }

  if (
    decoded.toLowerCase().includes("unauthorized_client") &&
    decoded.toLowerCase().includes("consumers")
  ) {
    return (
      "This Microsoft app is not registered for personal accounts. " +
      "Use your organization's tenant ID (directory GUID) in Admin Microsoft OAuth settings, " +
      "or set tenant ID to consumers only if the Azure app supports personal accounts."
    );
  }

  const shortMatch = decoded.match(/^AADSTS\d+:\s*([^.]+\.?)/);
  if (shortMatch?.[1]) {
    return shortMatch[1].trim();
  }

  return decoded.length > 320 ? `${decoded.slice(0, 317)}...` : decoded;
}
